import { DEFAULT_ENV, ENV_KEYS } from "./envSchema";
import { getRuntimeConfigValue } from "./runtimeConfig";

const env = import.meta.env || {};

const readEnv = (key, fallback = "") => {
  const envKey = ENV_KEYS[key];
  const envValue = envKey ? env[envKey] : undefined;
  return getRuntimeConfigValue(key, envValue ?? fallback);
};

export const appConfig = {
  projectName: readEnv("projectName", DEFAULT_ENV.projectName),
  apiServerUrl: readEnv("apiServerUrl"),
  apiServerFileUrl: readEnv("apiServerFileUrl"),
  watcherServerUrl: readEnv("watcherServerUrl"),
  ragHubServerUrl: readEnv("ragHubServerUrl"),
  deployLogServerUrl: readEnv("deployLogServerUrl"),
  aiNativeHubUrl: readEnv("aiNativeHubUrl"),
  helpAiChatUrl: readEnv("helpAiChatUrl"),
  publicUrl: readEnv("publicUrl", DEFAULT_ENV.publicUrl),
  siteTitle: readEnv("siteTitle", DEFAULT_ENV.siteTitle),
  buttonStyle: readEnv("buttonStyle", DEFAULT_ENV.buttonStyle),
  auth: readEnv("auth", DEFAULT_ENV.auth) === "true",
  backendType: readEnv("backendType", DEFAULT_ENV.backendType),
};

export default appConfig;
